import { put, takeEvery, call, all } from 'redux-saga/effects';
import { fetchDocumentsData, fetchDeclarationDocuments } from '../api';
import * as types from './documents.types';
import { showDialog } from '../dialog/dialog.actions';

function* getDocumentsData(fetchDocumentsDataFn, fetchDeclarationDocumentsFn) {
  try {
    const [documents, templates] = yield all([
      call(fetchDocumentsDataFn),
      call(fetchDeclarationDocumentsFn),
    ]);
    if (documents.ok && templates.ok) {
      yield put({
        type: types.FETCH_DOCUMENTS_SUCCESS,
        data: { documents: documents.resp, templates: templates.resp },
      });
    } else {
      yield put({ type: types.FETCH_DOCUMENTS_FAILURE });
      yield put(showDialog('DOC_LIST_ERROR'));
    }
  } catch (e) {
    yield put({ type: types.FETCH_DOCUMENTS_FAILURE });
    yield put(showDialog('DOC_LIST_ERROR'));
  }
}

function* documentsSaga() {
  yield takeEvery(
    types.FETCH_DOCUMENTS,
    getDocumentsData,
    fetchDocumentsData,
    fetchDeclarationDocuments
  );
}

export { getDocumentsData, documentsSaga };
